import { loadingOpacityMixin, Media, TokenAmount, UI } from '@cowprotocol/ui'

import styled, { css } from 'styled-components/macro'

import Input from 'legacy/components/NumericalInput'

export const OuterWrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-flow: column wrap;
`

export const Wrapper = styled.label<{ withReceiveAmountInfo: boolean; readOnly: boolean; pointerDisabled: boolean }>`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  align-content: space-between;
  gap: 10px;
  padding: 16px;
  background: ${({ readOnly }) => (readOnly ? 'transparent' : `var(${UI.COLOR_PAPER_DARKER})`)};
  border: ${({ readOnly }) => (readOnly ? `1px solid var(${UI.COLOR_PAPER_DARKER})` : 'none')};
  border-radius: ${({ withReceiveAmountInfo }) => (withReceiveAmountInfo ? '16px 16px 0 0' : '16px')};
  color: inherit;
  min-height: 106px;
  pointer-events: ${({ pointerDisabled }) => (pointerDisabled ? 'none' : '')};
  max-width: 100%;

  ${({ pointerDisabled }) =>
    pointerDisabled &&
    css`
      &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        cursor: not-allowed;
        pointer-events: auto;
      }
    `}

  ${Media.upToSmall()} {
    padding: 16px 12px;
  }
`

export const CurrencyInputBox = styled.div<{ isInvalid?: boolean }>`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: max-content;
  word-break: break-all;
  gap: 16px;
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  color: ${({ isInvalid }) => (isInvalid ? `var(${UI.COLOR_RED})` : 'inherit')};

  ${Media.upToSmall()} {
    gap: 8px;
  }

  ${Media.upToTiny()} {
    grid-template-columns: repeat(1, auto);
    grid-template-rows: max-content;
  }

  > div {
    display: flex;
    align-items: center;
    color: inherit;
  }

  > div:last-child {
    text-align: right;
    margin: 0 0 0 auto;
  }
`

export const CurrencyTopLabel = styled.div`
  font-size: 13px;
  font-weight: 400;
  margin: auto 0;
  color: inherit;
  opacity: 0.7;
  transition: opacity var(${UI.ANIMATION_DURATION}) ease-in-out;

  &:hover {
    opacity: 1;
  }
`

export const TopRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`

export const NumericalInput = styled(Input)<{ $loading: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background: none;
  font-size: 28px;
  font-weight: 500;
  color: inherit;
  text-align: left;

  &::placeholder {
    opacity: 0.7;
    color: inherit;
  }

  ${Media.upToSmall()} {
    font-size: 26px;
  }

  ${loadingOpacityMixin}
`

export const TokenAmountStyled = styled(TokenAmount)`
  font-size: 28px;
  font-weight: 500;
  color: inherit;

  ${Media.upToSmall()} {
    font-size: 26px;
  }
`

export const BalanceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
`

export const BalanceText = styled.span`
  font-weight: inherit;
  font-size: 13px;
  gap: 5px;
  display: inline-flex;
  align-items: center;
  opacity: 0.7;
  transition: opacity var(${UI.ANIMATION_DURATION}) ease-in-out;
  color: inherit;

  &:hover {
    opacity: 1;
  }
`

export const PercentButtonGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const PercentBtn = styled.button<{ $isActive?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 11px;
  line-height: 1;
  background: ${({ $isActive }) => ($isActive ? `var(${UI.COLOR_PRIMARY})` : `var(${UI.COLOR_PAPER})`)};
  color: ${({ $isActive }) => ($isActive ? `var(${UI.COLOR_BUTTON_TEXT})` : `inherit`)};
  border-radius: 6px;
  padding: 4px 6px;
  min-height: 22px;
  min-width: 32px;
  border: 0;
  outline: none;
  cursor: pointer;
  white-space: nowrap;
  text-transform: uppercase;
  user-select: none;
  transition:
    background var(${UI.ANIMATION_DURATION}) ease-in-out,
    color var(${UI.ANIMATION_DURATION}) ease-in-out,
    transform var(${UI.ANIMATION_DURATION}) ease-in-out;

  &:hover {
    background: var(${UI.COLOR_PRIMARY});
    color: var(${UI.COLOR_BUTTON_TEXT});
  }

  &:active {
    transform: scale(0.96);
  }

  ${Media.upToSmall()} {
    padding: 3px 5px;
    font-size: 10px;
    min-height: 20px;
    min-width: 28px;
  }
`

export const FiatAmountText = styled.span`
  // TODO: inherit font styles from 'CurrencyInputBox' instead
  color: inherit;

  > div {
    font-weight: 500;
    font-size: 13px;
    color: inherit;
    transition: opacity var(${UI.ANIMATION_DURATION}) ease-in-out;
  }
`

export const SetMaxBtn = PercentBtn
